/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M4 2C1.7909 2 0 3.7909 0 6v12c0 2.2091 1.7909 4 4 4h16c2.2091 0 4-1.7909 4-4V6c0-2.2091-1.7909-4-4-4H4Zm3.5 4H6c-1.1046 0-2 .8954-2 2v2h1.5V8a.5.5 0 0 1 .5-.5h1.5V6ZM4 14v2c0 1.1046.8954 2 2 2h1.5v-1.5H6a.5.5 0 0 1-.5-.5v-2H4Zm6.5-8h3v1.5h-3V6ZM18 6h-1.5v1.5H18a.5.5 0 0 1 .5.5v2H20V8c0-1.1046-.8954-2-2-2Zm2 8v2c0 1.1046-.8954 2-2 2h-1.5v-1.5H18a.5.5 0 0 0 .5-.5v-2H20Zm-9.5 4h3v-1.5h-3V18Z"
    clipRule="evenodd"
  />,
  'MenuContainersFilled'
);
